import { render } from "./DeletePaymentMethodModal.vue?vue&type=template&id=41e7da2d&ts=true"
import script from "./DeletePaymentMethodModal.vue?vue&type=script&lang=ts"
export * from "./DeletePaymentMethodModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList});
